import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = { class: "page-container card col-md-8" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "row p-3" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row p-3 pb-0" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Search existing CWK by:")
  ])
], -1)
const _hoisted_10 = { class: "row p-3 pb-0" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "row p-3" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "row p-3" }
const _hoisted_17 = { class: "col-md-5 d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_19 = { class: "col-md-7" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-12 p-4" }
const _hoisted_22 = { class: "p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12" }
const _hoisted_23 = { class: "p-datatable-thead" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }, "#", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, "Creation Date", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, "Conso Group Date", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"10%"},
  class: "text-center"
}, "Status", -1)
const _hoisted_28 = {
  key: 0,
  class: "p-datatable-tbody"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TheTableLoading = _resolveComponent("TheTableLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ThePageHeader, { pageTitle: _ctx.pageTitle }, null, 8, ["pageTitle"]),
              (_ctx.pageError == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Button, {
                          class: "p-button-sm",
                          onClick: _ctx.add,
                          label: "Create New CWK",
                          hidden: _ctx.isViewer
                        }, null, 8, ["onClick", "hidden"])
                      ])
                    ]),
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_InputText, {
                          class: "p-inputtext",
                          type: "text",
                          maxlength: "100",
                          placeholder: "Conso Group",
                          modelValue: _ctx.filterConsoGroupModel.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterConsoGroupModel.value) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_Calendar, {
                          dateFormat: "yy-mm-dd",
                          selectionMode: "range",
                          manualInput: true,
                          placeholder: "Balance Sheet Date (range)",
                          modelValue: _ctx.filterBalanceSheetDateModel,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterBalanceSheetDateModel) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_InputText, {
                          class: "p-inputtext",
                          type: "text",
                          maxlength: "50",
                          placeholder: "File ID",
                          modelValue: _ctx.filterFileIdModel.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterFileIdModel.value) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_Dropdown, {
                          options: _ctx.cwkApplicationStatuses,
                          optionLabel: "name",
                          optionValue: "value",
                          placeholder: "Status",
                          modelValue: _ctx.filterStatusModel.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterStatusModel.value) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_Button, {
                          class: "p-button-sm",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.find(1))),
                          label: "Search"
                        }),
                        _hoisted_18,
                        _createVNode(_component_Button, {
                          class: "p-button-sm p-button-secondary",
                          onClick: _ctx.reset,
                          label: "Reset"
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        (_ctx.pagination.currentPage != 0)
                          ? (_openBlock(), _createBlock(_component_Paginator, {
                              key: 0,
                              first: _ctx.paginator,
                              pageLinkSize: 3,
                              rows: _ctx.pagination.itemsPerPage,
                              totalRecords: _ctx.pagination.totalItems,
                              onPage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.find($event.page + 1)))
                            }, null, 8, ["first", "rows", "totalRecords"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("table", _hoisted_22, [
                          _createElementVNode("thead", _hoisted_23, [
                            _createElementVNode("tr", null, [
                              _hoisted_24,
                              _createElementVNode("th", {
                                style: {"width":"20%","cursor":"pointer"},
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sort('x.balanceSheetDate')))
                              }, [
                                _createTextVNode("File ID "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.balanceSheetDate' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _hoisted_25,
                              _hoisted_26,
                              _createElementVNode("th", {
                                style: {"width":"23%","cursor":"pointer"},
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('x.consoGroupName')))
                              }, [
                                _createTextVNode("Conso Group "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.consoGroupName' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _createElementVNode("th", {
                                style: {"width":"10%","cursor":"pointer"},
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sort('x.templateVersion'))),
                                class: "text-center"
                              }, [
                                _createTextVNode("Version "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.templateVersion' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _hoisted_27
                            ])
                          ]),
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_28, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.companyReports, (companyReport, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: index,
                                    onClick: ($event: any) => (_ctx.view(companyReport))
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(((_ctx.pagination.currentPage - 1) * _ctx.pagination.itemsPerPage) + index + 1), 1),
                                    _createElementVNode("td", null, _toDisplayString(companyReport.fileId), 1),
                                    _createElementVNode("td", null, _toDisplayString((companyReport.statusDate)), 1),
                                    _createElementVNode("td", null, _toDisplayString((companyReport.consoGroupDate)), 1),
                                    _createElementVNode("td", null, _toDisplayString(companyReport.consoGroupName), 1),
                                    _createElementVNode("td", _hoisted_30, _toDisplayString(companyReport.templateVersion), 1),
                                    _createElementVNode("td", _hoisted_31, [
                                      _createVNode(_component_Badge, {
                                        class: _normalizeClass(["mr-2", [companyReport.status == 'Finalised' ? 'p-badge-success' : (companyReport.status == 'Cancelled' ? 'p-badge-danger' : 'p-badge-warning')]]),
                                        value: companyReport.status
                                      }, null, 8, ["class", "value"])
                                    ])
                                  ], 8, _hoisted_29))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (!_ctx.isLoading && _ctx.pagination.companyReports.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createVNode(_component_FontAwesomeIcon, {
                              icon: ['fas', 'image'],
                              size: "2x"
                            }),
                            _hoisted_33
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 1 }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pageError != '')
                ? (_openBlock(), _createBlock(_component_ThePageError, {
                    key: 1,
                    onBackEvent: _ctx.cancel,
                    pageError: _ctx.pageError
                  }, null, 8, ["onBackEvent", "pageError"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}